import { Tag } from 'antd';

import { ESchoolTypeToText } from '../../../consts';

import styles from './StatusTag.module.scss';

interface IProp {
  isPublished: boolean;
}

export const StatusTag = ({ isPublished }: IProp) => {
  switch (isPublished) {
    case true:
      return (
        <Tag
          className={styles.tag}
          color="green"
        >
          {ESchoolTypeToText.Published.toUpperCase()}
        </Tag>
      );
    case false:
      return (
        <Tag
          className={styles.tag}
          color="volcano"
        >
          {ESchoolTypeToText.UnPublished.toUpperCase()}
        </Tag>
      );
  }
};
